import moduleName from '../moduleName';

export default {
  AUTHORS: `${moduleName}/authors`,
};
